import { stableStringifyObject } from 'dex-app.cm';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { Tracker } from '@/types';

type TrackersStore = {
  trackers: Tracker[];
  addTracker: (newTracker: Tracker) => void;
  removeTracker: (tracker: Tracker) => void;
  updateTracker: (updatedTracker: Partial<Tracker> & { unique: string }) => void;
};

export const useTrackersStore = create(
  persist<TrackersStore>(
    (set) => {
      return {
        trackers: [],
        addTracker: (newTracker) => {
          set((state) => {
            const stringifyTracker = stableStringifyObject(newTracker);

            if (state.trackers.some((tracker) => stableStringifyObject(tracker) === stringifyTracker)) {
              return state;
            }

            return { trackers: [...state.trackers, newTracker] };
          });
        },
        removeTracker: (newTracker) => {
          set((state) => {
            const stringifyTracker = stableStringifyObject(newTracker);

            return {
              trackers: state.trackers.filter((tracker) => stableStringifyObject(tracker) !== stringifyTracker),
            };
          });
        },
        updateTracker: (updatedTracker) => {
          // idempotent, uniqueness by unique field
          set((state) => ({
            trackers: state.trackers.map((tracker) =>
              tracker.unique === updatedTracker.unique ? { ...tracker, ...updatedTracker } : tracker
            ),
          }));
        },
      };
    },
    {
      name: 'trackers',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
